/* src/app/features/inadimplencia/pesquisa/listagem/inadimplencia-listagem.component.scss */
.letra-miuda {
  font-size: 14px;
  font-style: italic;
  text-align: bottom;
}
/*# sourceMappingURL=inadimplencia-listagem.component.css.map */
